import React from 'react';

// Number input with a persistent unit suffix ("lb" / "reps") anchored inside
// the field, so a bare "135" always reads as "135 lb" rather than an
// ambiguous number. Used everywhere weight/reps are entered or edited.
const AmountInput = ({
  value,
  onChange,
  onBlur,
  unit,
  placeholder,
  inputClassName = "comic-input",
  inputStyle = {},
  wrapperStyle = {}
}) => (
  <div style={{ position: "relative", ...wrapperStyle }}>
    <input
      type="number"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={inputClassName}
      style={{ width: "100%", paddingRight: "44px", ...inputStyle }}
    />
    <span
      aria-hidden="true"
      style={{
        position: "absolute",
        right: "14px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#888",
        fontSize: "13px",
        fontFamily: "'Anonymous Pro', monospace",
        pointerEvents: "none"
      }}
    >
      {unit}
    </span>
  </div>
);

export default AmountInput;
